import { BaseApi } from "./Base";

class PickupInstructionApi extends BaseApi {
  createPickupInstruction(data) {
    return super.postApiRequest("/pickup-instructions", data);
  }

  getPickupInstructions(operator, zip) {
    const params = { operator };

    if (zip) {
      params.zip = zip;
    }

    return super.getApiRequest("/pickup-instructions", params);
  }

  getPickupInstructionById(instructionId) {
    return super.getApiRequest(`/pickup-instructions/${instructionId}`);
  }

  updatePickupInstruction(instructionId, data) {
    return super.putApiRequest(`/pickup-instructions/${instructionId}`, data);
  }

  deletePickupInstruction(instructionId) {
    return super.deleteApiRequest(`/pickup-instructions/${instructionId}`);
  }
}

const pickupInstructionApi = new PickupInstructionApi();

export default pickupInstructionApi;
